import TileImageClass, * as TileImageModule from './../../node_modules/ol/source/TileImage.js';

class TileImage extends TileImageClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileImageModule) {
    if (key !== "default") {
        TileImage[key] = TileImageModule[key];
    }
}

export default TileImage;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/TileImage.js';